import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const changeAgttp = (newAgttp) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/auth/change-user-type`, {
      newUserType: newAgttp,
    }, {
      headers: authHeader(),
    })
    .then((response) => {
      toast.success(response.data.msg);
      return response.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Failed to change user type");
      throw err;
    });
}; 